// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import Condition from './Condition'
import styled, { type StyledComponent } from 'styled-components'
import type { ConditionType, OptionType } from '../types'
import ErrorText from '../controls/ErrorText'
import PrimaryButton from '../controls/PrimaryButton'
import { grayColor, linkColor } from '../controls/colors'
import { BoldText } from '../AutomatedRulesTable/AutomatedRulesTableRow'

const ConditionRow: StyledComponent<Object, any, any> = styled.div`
  display: table;
  width: 100%;
  padding-bottom: 5px;
`

const ConditionWrapper: StyledComponent<Object, any, any> = styled.div`
  display: table-cell;
  width: 60%;
`

const DeleteButtonWrapper: StyledComponent<Object, any, any> = styled.div`
  display: table-cell;
  width: 20px;
  vertical-align: middle;
`

const DeleteButton: StyledComponent<Object, any, any> = styled.div`
  padding-left: 2px;
  text-decoration: none;
  color: ${({ disabled }: Object) => (disabled ? grayColor : linkColor)};

  &:hover {
    cursor: ${({ disabled }: Object) => (disabled ? 'default' : 'pointer')};
  }
`

const AddButtonWrapper: StyledComponent<Object, any, any> = styled.div`
  padding-top: 5px;
`

const AddButton: any = styled(PrimaryButton)`
  width: 25%;
  font-size: 16px;
`

type Props = {|
  t: Function,
  conditions: Array<ConditionType>,
  options: Array<OptionType>,
  conditionsErrors?: Array<Object>,
  isOnlyInfo?: boolean,
  disabled?: boolean,
  onClearErrors?: Function,
  onChange?: Function
|}

type State = {|
  newConditionType: string
|}

export default class Conditions extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = { newConditionType: 'impressions' }
  }

  render() {
    const {
      isOnlyInfo,
      conditions,
      options,
      disabled,
      t,
      conditionsErrors,
      onClearErrors
    } = this.props

    if (isOnlyInfo) {
      return (
        <div>
          <BoldText>{t('conditions')}</BoldText>
          {conditions.map((condition, index) => (
            <Condition t={t} key={index} options={options} condition={condition} isOnlyInfo />
          ))}
        </div>
      )
    }
    return (
      <div>
        {conditions.map((condition, index) => (
          <ConditionRow key={index}>
            <ConditionWrapper>
              <Condition
                key={index}
                t={t}
                options={options}
                condition={condition}
                disabled={disabled}
                onChange={(condition) => {
                  onClearErrors && onClearErrors({ conditionsErrors: {} })
                  this.conditionChanged(condition, index)
                }}
              />
              {conditionsErrors && conditionsErrors[index] && (
                <ErrorText errors={conditionsErrors[index].value} />
              )}
            </ConditionWrapper>
            <DeleteButtonWrapper>
              <DeleteButton disabled={disabled} onClick={() => this.deleteCondition(index)}>
                [×]
              </DeleteButton>
            </DeleteButtonWrapper>
          </ConditionRow>
        ))}
        {_.size(conditions) < 5 && (
          <AddButtonWrapper>
            <AddButton small height={36} disabled={disabled} onClick={() => this.addCondition()}>
              {t('add_condition')}
            </AddButton>
          </AddButtonWrapper>
        )}
      </div>
    )
  }

  newConditionTypeChanged(newConditionType: string) {
    this.setState({ newConditionType })
  }

  addCondition() {
    let conditions = _.cloneDeep(this.props.conditions)
    const { onChange } = this.props

    onChange &&
      onChange(
        _.concat(conditions, {
          condition_type: 'metrics',
          name: this.state.newConditionType,
          comparison: 'more',
          period: 'today'
        })
      )
  }

  deleteCondition(index: number) {
    let conditions = _.cloneDeep(this.props.conditions)
    const { onChange } = this.props

    onChange && onChange(_.without(conditions, conditions[index]))
  }

  conditionChanged(condition: ConditionType, index: number) {
    let conditions = _.cloneDeep(this.props.conditions)

    conditions[index] = condition
    this.props.onChange && this.props.onChange(conditions)
  }
}
